/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of the device.
 */
export enum DeviceSummaryStatusType {
  DeviceSummaryStatusOnline = 'Online',
  DeviceSummaryStatusDegraded = 'Degraded',
  DeviceSummaryStatusError = 'Error',
  DeviceSummaryStatusRebooting = 'Rebooting',
  DeviceSummaryStatusPoweredOff = 'PoweredOff',
  DeviceSummaryStatusUnknown = 'Unknown',
  DeviceSummaryStatusAwaitingReconnect = 'AwaitingReconnect',
  DeviceSummaryStatusConflictPaused = 'ConflictPaused',
}
